import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-footer d-flex justify-content-between"
}
const _hoisted_2 = { class: "indicator-label" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode("Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.showModal,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showModal) = $event)),
    title: _ctx.title,
    "close-on-click-modal": false,
    "close-on-press-escape": false,
    "destroy-on-close": true,
    "modal-class": _ctx.modalClass,
    onClose: _ctx.close
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["modal-body bg-opacity-50 bg-light scroll-y", [_ctx.widthClass, _ctx.heightClass]])
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2),
      (!_ctx.noActions)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "actions", {
              reject: _ctx.reject,
              confirm: _ctx.confirm
            }, () => [
              _renderSlot(_ctx.$slots, "secondary-actions", {
                reject: _ctx.reject,
                confirm: _ctx.confirm
              }, () => [
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                }, _toDisplayString(_ctx.cancelLabel), 1)
              ]),
              _renderSlot(_ctx.$slots, "primary-actions", {
                reject: _ctx.reject,
                confirm: _ctx.confirm
              }, () => [
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
                }, [
                  _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.confirmLabel), 1),
                  _hoisted_3
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["modelValue", "title", "modal-class", "onClose"]))
}